<template>
  <div
    class="webzineMagazine__container fullscreen stickActive"
    ref="webzineParent"
    :style="{ '--windowHeight': this.windowHeight + 'px' }"
  >
    <nav class="stickyNavigation__container" ref="stickyNav">
      <ul :class="childStickyClass">
        <li
          v-for="(item, index) in bannerData.categories.slice(0, 8)"
          :class="{ active: `webzine_${index}` === activeElement }"
          :key="index"
        >
          <button
            @keydown.enter="enterscrollToElement('webzine_'.concat(index))"
            @click="clickScrollToElement('webzine_'.concat(index));dataLayerPush(item.categoryClickTagging)"
          >
            <strong>{{ '0' + (index + 1) }}</strong>
            <span>{{ item.categoryName }}</span>
          </button>
        </li>
      </ul>
    </nav>

    <div class="webzineCatagory__container" ref="webzineCatagory">
      <section
        v-for="(item, index) in this.bannerData.categories.slice(0, 8)"
        class="webzineCatagory__list"
        :data-id="'webzine_' + index"
        :key="index"
        :class="[getMediaClass(item), 'webzine_' + index]"
      >
        <div class="webzineCatagory__banner item">
          <webzine-magazine-banner :initialdata="item" :bannerindex="index" />
        </div>

        <div
          class="webzineCatagory__banner-spacer"
          :id="'webzine_'.concat(index)"
          :data-header-color="item.menuColor"
          ref="spacerElement"
          :data-index="index"
        ></div>

        <div
          class="webzineCatagory__article item"
          :class="{ rightMainCategory: item.ishiglightedarticleonright }"
        >
          <webzine-magazine-article
            :initialdata="bannerData"
            :categorydata="item"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import webzineMagazineBanner from './webzine-magazine-banner.vue';
import webzineMagazineArticle from './webzine-magazine-article.vue';
export default {
  name: 'webzineMagazine',
  components: {
    webzineMagazineBanner,
    webzineMagazineArticle,
  },
  props: {
    bannerData: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      childStickyClass: '',
      isScrolledToBottom: false,
      windowHeight: window.innerHeight,
      addActiveNav: false,
      isActive: true,
      activeElement: 'webzine_0',
      inViewport: [],
      translateY: 70,
      scrollY: 0,
      smallScreen: window.matchMedia('(max-width: 1023px)').matches,
      visibleSections: [],
    };
  },
  mounted() {
    setTimeout(() => {
      const firstBannerContent = document.querySelector(
        '.webzineCatagory__bannerContent_section'
      );

      if (firstBannerContent) {
        firstBannerContent.classList.add('firstCategryTextAnimation');

        setTimeout(() => {
          firstBannerContent.classList.remove('firstCategryTextAnimation');
          firstBannerContent.classList.add('firstCategry');
        }, 700);
      }
      this.handleScroll();
    }, 500);
    window.addEventListener('resize', this.updateWindowHeight);
    this.observeListItems();
    this.stickynav();
    window.addEventListener('scroll', this.checkScrollPosition);

    this.headercolorchange();
    this.checkScrollPosition();
    this.clickScrollToElement();
  },

  methods: {
    handleScroll() {
      const listOfCaterody = this.getListOfCaterody();
      const windowHeight = window.innerHeight;

      listOfCaterody.forEach((el) => {
        const webzineBannerArticle = el.querySelector(
          '.webzineMagazineArticle__container'
        );
        const rect = webzineBannerArticle.getBoundingClientRect();

        const start = windowHeight;
        const end = windowHeight * 0.1;

        let opacity = 0;

        if (rect.top < start && rect.top > end) {
          opacity = 1 - (rect.top - end) / (start - end);
        } else if (rect.top <= end) {
          opacity = 1;
        } else {
          opacity = 0;
        }

        opacity = Math.max(0, Math.min(1, opacity));

        webzineBannerArticle.style.opacity = opacity.toFixed(2);
      });
    },
    getMediaClass(item) {
      if (
        item &&
        ((!this.smallScreen && item.desktopMp4?.src) ||
          (this.smallScreen && item.mobileMp4?.src))
      ) {
        return 'has-video';
      } else {
        return 'has-picture';
      }
    },
    getListOfCaterody() {
      return this.$refs.webzineCatagory.querySelectorAll(
        '.webzineCatagory__list'
      );
    },
    scallingText() {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        const webzineBannerSpacer = entry.querySelector(
          '.webzineCatagory__banner-spacer'
        );

        const webzineBannerContent = entry.querySelector(
          '.webzineCatagory__bannerContent_section'
        );
        if (webzineBannerContent) {
          const rect = webzineBannerSpacer.getBoundingClientRect();
          const vh = window.innerHeight;
          const windowHeight = window.innerHeight;
          const halfWindowHeight = windowHeight / 8;
          if (rect.top <= vh && rect.top >= halfWindowHeight) {
            this.translateY = 15 * (rect.top / vh);
            webzineBannerContent.style.transform = `translate3d(0px, 0px, 0px) translate(0, ${
              this.translateY + '%'
            })`;
          } else {
            webzineBannerContent.style.transform = `translate3d(0px, 0px, 0px) translate(0px, 0%)`;
          }
        }
      });
    },
    scallingBanner() {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        const webzineBannerSpacer = entry.querySelector(
          '.webzineCatagory__banner-spacer'
        );
        const webzineBanner = entry.querySelector(
          '.webzineCatagory__banner .scallingMedia'
        );

        if (webzineBanner) {
          const spacerBottom = webzineBannerSpacer.getBoundingClientRect().top;
          const windowHeight = window.innerHeight;
          const halfWindowHeight = windowHeight / 4;

          if (
            spacerBottom <= windowHeight &&
            spacerBottom >= halfWindowHeight
          ) {
            const progress =
              (spacerBottom - halfWindowHeight) /
              (windowHeight - halfWindowHeight);
            const scale = 1 + 0.17 * progress;
            webzineBanner.style.transform = `translate3d(0, 0, 0) scale(${scale}, ${scale})`;
          } else {
            webzineBanner.style.transform = 'translate3d(0, 0, 0) scale(1, 1)';
          }
        }
      });
    },
    headercolorchange() {
      const listOfCaterody = this.getListOfCaterody();
      const bodySelector = document.querySelector('body');
      bodySelector.classList.add(this.bannerData.categories[0].menuColor);
      listOfCaterody.forEach((entry) => {
        const webzineBannerSpacer = entry.querySelector(
          '.webzineCatagory__banner-spacer'
        );

        const getHeaderColor =
          webzineBannerSpacer.getAttribute('data-header-color');
        const webzineBannerSpacerRecbottom =
          webzineBannerSpacer.getBoundingClientRect().bottom;
        if (
          webzineBannerSpacerRecbottom <= innerHeight &&
          webzineBannerSpacerRecbottom >= 60 &&
          getHeaderColor
        ) {
          bodySelector.classList.add(getHeaderColor);
        }
        if (webzineBannerSpacerRecbottom < 59 && getHeaderColor) {
          bodySelector.classList.remove('white');
          bodySelector.classList.remove('black');
        }
      });
    },
    horizontalNavScroll() {
      const getNavEl = this.$refs.stickyNav;
      setTimeout(() => {
        if (getNavEl && this.smallScreen) {
          return getNavEl?.querySelector('ul > li.active').scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }
      }, 200);
    },
    stickynav() {
      const rectListItem = this.$refs.webzineCatagory.getBoundingClientRect();
      const webzineParent = this.$refs.webzineParent;

      if (rectListItem.bottom >= window.innerHeight || rectListItem.top >= 0) {
        webzineParent.classList.add('stickActive');
        webzineParent.classList.remove('stickInActive');
      } else {
        webzineParent.classList.remove('stickActive');
        webzineParent.classList.add('stickInActive');
      }
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
      this.horizontalNavScroll();
      this.getMediaClass();
    },
    enterscrollToElement(index) {
      setTimeout(() => {
        this.smoothScroll(index);
      }, 150);
    },
    clickScrollToElement(index) {
      setTimeout(() => {
        this.smoothScroll(index);
      }, 150);
      this.scallingText();
    },
    smoothScroll(index) {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        let getCategoryattr = entry.getAttribute('data-id');
        if (index === getCategoryattr) {
          const genId = '#'.concat(getCategoryattr);
          const genClass = '.'.concat(getCategoryattr);

          if (
            (navigator.platform.toLowerCase().includes('mac') ||
              /iPad|iPhone/.test(navigator.userAgent)) &&
            !('ontouchstart' in window)
          ) {
           
            document
              .querySelector(genClass)
              .scrollIntoView({ behavior: 'smooth' });
          } else {
           
            VueScrollTo.scrollTo(genId, {
              duration: 800,
              easing: 'linear',
              offset: 0,
              x: false,
              y: true,
            });
          }
        }
      });
    },

    checkScrollPosition() {
      const listOfCaterody = this.getListOfCaterody();
      listOfCaterody.forEach((entry) => {
        const articleBanner = entry.querySelector('.webzineCatagory__article');
        const articleBannerRect = articleBanner.getBoundingClientRect().top;
        const articleBannerRightColomn = entry.querySelector(
          '.webzineCatagory__article.rightMainCategory'
        );
        if (articleBannerRect <= 0) {
          entry.classList.add('articleTop');
        } else {
          entry.classList.remove('articleTop');
        }
        this.handleArticleAnimations(entry, !!articleBannerRightColomn);
      });

      setTimeout(() => {
        const getActiveElement =
          this.$refs.webzineCatagory.querySelector('.in-viewport');
        if (getActiveElement) {
          const getDataId = getActiveElement.getAttribute('data-id');
          this.activeElement = getDataId;
        }
      }, 100);

      this.stickynav();
      this.horizontalNavScroll();
      this.headercolorchange();
      this.scallingBanner();
      this.scallingText();
      this.handleScroll();
    },
    applyTranslateAnimation(element, delay, shouldAdd) {
      const translateIn = 'translate-in';
      element.style.transitionDelay = delay;
      if (shouldAdd) {
        element.classList.add(translateIn);
      } else {
        element.classList.remove(translateIn);
      }
    },
    handleArticleAnimations(entry, hasRightColumn) {
      const first = entry.querySelector('.first');
      const second = entry.querySelector('.second');
      const third = entry.querySelector('.third');

      const firstRect = first.getBoundingClientRect().top;
      const secondRect = second.getBoundingClientRect().top;
      const thirdRect = third.getBoundingClientRect().top;

      const threshold = window.innerHeight / 1.1;

      this.applyTranslateAnimation(first, firstRect < threshold ? '0.3s' : '0.9s', firstRect < threshold);

      if (hasRightColumn) {
        this.applyTranslateAnimation(second, secondRect < threshold ? '0.9s' : '0.3s', secondRect < threshold);
        this.applyTranslateAnimation(third, '0.6s', thirdRect < threshold);
      } else {
        this.applyTranslateAnimation(second, '0.6s', secondRect < threshold);
        this.applyTranslateAnimation(third, thirdRect < threshold ? '0.9s' : '0.3s', thirdRect < threshold);
      }
    },
    observeListItems() {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-viewport');
              entry.target.classList.remove('out-viewport');
            } else {
              entry.target.classList.remove('in-viewport');
              entry.target.classList.add('out-viewport');
            }
          });
        },
        {
          threshold: 0.001,
        }
      );

      this.$refs.webzineCatagory
        .querySelectorAll('.webzineCatagory__list')

        .forEach((item) => {
          observer.observe(item);
        });
    },
    dataLayerPush(taggingVal) {
      try {
        const eventData = typeof taggingVal === "string" ? JSON.parse(taggingVal) : taggingVal;
        window.dataLayer.push(eventData);
      } catch (error) {
        console.warn('Failed to parse tagging:', error);
      }
    }
  },

  destroyed() {
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('resize', this.updateWindowHeight);
  },
};
</script>
